import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import {
  LOOKUPLIST_GETALL_API,
  LOOKUP_LIST_CHEMISTRY_API,
  LOOKUPLIST_API,
  LOOKUP_LIST_DELETEWITHCHECK_API
} from './config';

export function getAll() {
  return getFetch(LOOKUPLIST_GETALL_API());
}

export function getListChemistry() {
  return getFetch(LOOKUP_LIST_CHEMISTRY_API());
}

export function updateOne(_id, data = {}) {
  return putFetch(`${LOOKUPLIST_API()}/${_id}`, data);
}


export function create(obj) {
  return postFetch(`${LOOKUPLIST_API()}`, {
    ...obj,
    ProvinceID: 2
  });
}

export function deleteOneWithCheck(_id, data = {}) {
  return deleteFetch(`${LOOKUP_LIST_DELETEWITHCHECK_API()}/${_id}`, data);
}


// WEBPACK FOOTER //
// ./src/api/lookuplistApi.js